'use strict';
define([
    './links/cookieService',
    '../../../lib/domQ',
    './miniBag/Index',
    '../data/config/app'
], function (mnsCookieService, domQ, MiniBagOverlay, config) {

    function MyBag(params) {
        this.basketCount = mnsCookieService.getBasketSizeCookieValue();
        this.miniBagOverlay = MiniBagOverlay;
        this.updateCount(params);
    }

    MyBag.prototype = {

        getByRegex: function (key) {
            var array = document.cookie.match(new RegExp(key + '=[^;]+', 'i'));
            if (array && array.length === 1) {
                return array[0].split('=')[1];
            } else {
                return 0;
            }
        },

        updateCount: function (params) {
            this.options = params;
            var self = this;
            // Update initial basket count
            this.options.myBagCount.innerHTML = this.basketCount;
            this.updateLayout();

            window.addEventListener('updateItemCount', function (e) {
                // Test For Minibag Sub Total
                setTimeout(function(){
                    if(window.mnsHeaderConfig && window.mnsHeaderConfig.adobeTargetTest) {
                        config = window.mnsHeaderConfig;
                    }
                    self.updateBasket(e.myBagCount);
                    self.miniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
                        miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + config.langId + '&storeId=' + config.storeId + '&catalogId=' + config.catalogId
                    });
                }, 1000);
            });
        },

        updateLayout: function () {
            if (parseInt(this.basketCount) > 0) {
                domQ(this.options.myBagElement).addClass('selected');
                domQ(this.options.checkoutElement).removeClass('navigation-res-nav-header__item--hidden');
                domQ(this.options.myBagIconElement).removeClass('navigation-res-icon--empty-my-bag');
                domQ(this.options.myBagIconElement).addClass('navigation-res-icon--fill-my-bag');
                domQ(this.options.myBagElement).removeClass('navigation-hdr-bag-unclick');
                var minibagChevronElement = document.querySelector('.navigation-chevronicon__minibag');
                if (minibagChevronElement && (minibagChevronElement.classList.contains('navigation-minibag-empty'))) {
                    domQ(document.querySelector('.navigation-chevronicon__minibag')).removeClass('navigation-minibag-empty');
                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty-display');
                }

            } else {
                domQ(this.options.myBagElement).removeClass('selected');
                domQ(this.options.checkoutElement).addClass('navigation-res-nav-header__item--hidden');
                domQ(this.options.myBagIconElement).removeClass('navigation-res-icon--fill-my-bag');
                domQ(this.options.myBagIconElement).addClass('navigation-res-icon--empty-my-bag');
                domQ(this.options.myBagElement).addClass('navigation-hdr-bag-unclick');
                if (document.querySelector('.navigation-chevronicon__minibag')) {
                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty');
                }
            }
        },

        updateBasket: function (myBagCount) {
            this.options.myBagCount.innerHTML = myBagCount;
            this.basketCount = myBagCount;
            this.updateLayout();
        }
    };

    return MyBag;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/MyBag.js